export const selectParameter = state => state.parameter;
export const selectParameterList = state => selectParameter(state).items;
export const selectParameterIva = state => selectParameter(state).iva;
export const selectParameterQueryOptions = state => {
  const { options } = selectParameter(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};

export const selectIndividualParameter = state =>
  selectParameter(state).parameter;

export const selectAdminPhonesParameter = state =>
  selectParameter(state).parameter;
